import React, { useContext, useMemo, useState } from "react";

import * as CHQ from "chq";

type ClickTransportState = {
  clickedUsers: CHQ.User[];
  clickedPagination: any;
  onClickRead: () => void;
  onUsersClicked: (_users: CHQ.User[], _pagination: any, _options: any) => void;
  onValuesClicked: (_values: CHQ.OrganizationValue[]) => void;
  onLandingPageClicked: (_landingPage: CHQ.LandingPage) => void;
};

const ClickTransportContext = React.createContext<ClickTransportState>({
  clickedUsers: [],
  clickedPagination: {},
  onClickRead: () => {},
  onUsersClicked: () => {},
  onValuesClicked: () => {},
  onLandingPageClicked: () => {}
});

export const ClickTransportProvider: React.FC = ({ children }) => {
  const [clickedUsers, setClickedUsers] = useState<CHQ.User[]>([]);
  const [clickedPagination, setUsersPagination] = useState<any>({});
  const [clickedOptions, setOptions] = useState<any>([]);
  const [clickedValues, setClickedValues] = useState<any>([]);
  const [landingPage, setLandingPage] = useState<any>([]);

  const value = useMemo(
    () => ({
      clickedUsers,
      clickedPagination,
      clickedOptions,
      clickedValues,
      landingPage,
      onClickRead: () => setClickedUsers([]),
      onUsersClicked: (users: CHQ.User[], pagination: any, options: any) => {
        setUsersPagination(pagination);
        setClickedUsers(users);
        setOptions(options);
      },
      onLandingPageClicked: (landingPage: CHQ.LandingPage) => {
        setLandingPage(landingPage);
      },
      onValuesClicked: (values: CHQ.OrganizationValue[]) => {
        setClickedValues(values);
      }
    }),
    [clickedUsers, setClickedUsers, clickedPagination, setUsersPagination, clickedOptions,
      setOptions, clickedValues, setClickedValues, landingPage, setLandingPage]
  );

  return (
    <ClickTransportContext.Provider value={value}>
      {children}
    </ClickTransportContext.Provider>
  );
};

export const useClickTransport = () => useContext(ClickTransportContext);
